import styled from 'styled-components';

export const Wrapper = styled.section`
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: #f2f2f2;
`;

export const InnerWrapper = styled.div`
  max-width: 1360px;
  padding: 0 16px;
  box-sizing: border-box;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  margin-top: 70px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 248px);
`;

export const Header = styled.h2`
  margin: 0 0 41px;
  width: 100%;
  font-family: MuseoSansRoundedBold;
  font-size: 75px;
  font-weight: 900;
  line-height: 0.92;
  text-align: center;
  color: #1b62ad;

  @media(max-width: 405px) {
    font-size: 34px;
  }
`;

export const ContactDataWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  margin: auto 0;
  flex-wrap: wrap;
`;

export const Footer = styled.footer`
  width: 100%;
  min-height: 178px;
  background-color: #fff;
  margin: auto 0 0;
`;

export const FooterBody = styled.div`
  box-sizing: border-box;
  max-width: 1420px;
  width: 100%;
  padding: 50px 16px;
  width: 100%;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
`;

export const CopyRight = styled.p`
  font-family: MuseoSansRounded;
  font-size: 19px;
  font-weight: 300;
  color: #404041;
  width: 455px;
`;

export const ItemWrapper = styled.div`
  display: flex;
  min-width: 182px;
  margin-bottom: 18px;

  @media(max-width: 880px) {
    min-width: 100%;
    padding-left: 30%;
  }

  @media(max-width: 400px) {
    padding-left: 20px;
  }
`;

export const ItemIcon = styled.img`
  width: 26px;
  height: 26px;
  margin-right: 13px;
  color: #1b62ad;
`;

export const ItemBody = styled.div``;

export const ItemHeader = styled.h6`
  font-family: Causten;
  font-size: 20px;
  font-weight: bold;
  color: #000;
  margin: 0;
`;

export const ItemText = styled.p`
  margin: 12px 0 0;
  font-family: Causten;
  font-size: 18px;
  color: #000;
`;

export const FoundsWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  flex-grow: 2;
`;

export const EuropeFunds = styled.img`
  object-fit: contain;
`;
